import { createSlice } from '@reduxjs/toolkit';

export interface BatchMasterItem {
  id: number;
  total_batches: number | null;
  ticketsGenerated?: number | null;
  ticketsProcessed?: number | null;
  status: string | null;
  process_id: number | null;
  eventId: string | null;
  tktRrpp: string | null;
  createUser: string | null;
  createUserName?: string | null;
  createdAt: string | null;
  tktType: string | null;
  tktDisplayName?: string | null;
  /** Si el tipo de ticket está vencido; si true no se puede reintentar envío */
  isOutDate?: boolean;
  paymentMethod: string | null;
  generationType: string | null;
  title: string | null;
}

export interface BatchMastersResponse {
  items: BatchMasterItem[];
  size: number;
  total: number;
}

interface TicketProcessState {
  batchMasters: BatchMastersResponse;
  isLoadingBatchMasters: boolean;
  errorBatchMasters: string | null;
  statusCodeBatchMasters: number;
}

const emptyBatchMasters: BatchMastersResponse = {
  items: [],
  size: 0,
  total: 0
};

const initialState: TicketProcessState = {
  batchMasters: emptyBatchMasters,
  isLoadingBatchMasters: false,
  errorBatchMasters: null,
  statusCodeBatchMasters: 200
};

export const ticketProcessSlice = createSlice({
  name: 'ticketProcess',
  initialState,
  reducers: {
    startLoadingBatchMasters: (state) => {
      state.isLoadingBatchMasters = true;
      state.errorBatchMasters = null;
      state.batchMasters = emptyBatchMasters;
    },
    setBatchMasters: (state, action: { payload: BatchMastersResponse }) => {
      state.batchMasters = action.payload;
      state.isLoadingBatchMasters = false;
      state.errorBatchMasters = null;
      state.statusCodeBatchMasters = 200;
    },
    setBatchMastersError: (state, action: { payload: { message: string; status?: number } }) => {
      state.isLoadingBatchMasters = false;
      state.errorBatchMasters = action.payload.message;
      state.statusCodeBatchMasters = action.payload.status ?? 500;
      state.batchMasters = emptyBatchMasters;
    },
    stopLoadingBatchMasters: (state) => {
      state.isLoadingBatchMasters = false;
    },
    resetBatchMasters: (state) => {
      state.batchMasters = emptyBatchMasters;
      state.errorBatchMasters = null;
      state.statusCodeBatchMasters = 200;
    }
  }
});

export const {
  startLoadingBatchMasters,
  setBatchMasters,
  setBatchMastersError,
  stopLoadingBatchMasters,
  resetBatchMasters
} = ticketProcessSlice.actions;
